"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var NOTIFICATION_UPDATE_INTERVAL = 60 * 1000; //ping every minute
var LAST_CLOSED_NOTIFICATION_KEY = "lastclosednotificationkey";
var Popup = function (props) {
    var _a = react_1.useState(false), open = _a[0], setOpen = _a[1];
    var _b = react_1.useState(), content = _b[0], setContent = _b[1];
    var _c = react_1.useState(), response = _c[0], setResponse = _c[1];
    react_1.useEffect(function () {
        var apiPinger = setInterval(function () {
            fetchData();
        }, NOTIFICATION_UPDATE_INTERVAL);
        fetchData();
        return function () { return clearInterval(apiPinger); };
    }, []);
    react_1.useEffect(function () {
        if (response && response.length > 0) {
            var lastItem = response[response.length - 1];
            if (isLatestClosed(lastItem)) {
                setOpen(false);
                return;
            }
            var areEqual = (content === null || content === void 0 ? void 0 : content.id) === lastItem.id && content.publishTimestamp === lastItem.publishTimestamp;
            if (!areEqual) {
                setContent(lastItem);
                setOpen(false);
                setTimeout(function () {
                    setOpen(true);
                }, 1000);
            }
        }
        else {
            setOpen(false);
        }
    }, [response, content]);
    function fetchData() {
        return __awaiter(this, void 0, void 0, function () {
            var response, notifications;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(props.endpointUrl)];
                    case 1:
                        response = _a.sent();
                        if (response.status !== 200) {
                            console.log("something went wrong");
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        notifications = _a.sent();
                        setResponse(notifications);
                        return [2 /*return*/];
                }
            });
        });
    }
    function closeMessage(content) {
        addToLocalStorage(LAST_CLOSED_NOTIFICATION_KEY, { id: content.id, timestamp: content.publishTimestamp });
        setOpen(false);
    }
    function isLatestClosed(content) {
        var currentLastClosed = getFromLocalStorage(LAST_CLOSED_NOTIFICATION_KEY);
        if (currentLastClosed && currentLastClosed.id === content.id && currentLastClosed.timestamp === content.publishTimestamp) {
            return true;
        }
        return false;
    }
    function addToLocalStorage(key, notification) {
        var jsonString = JSON.stringify(notification);
        localStorage.setItem(key, jsonString);
    }
    function getFromLocalStorage(key) {
        var localStorageContent = localStorage.getItem(key);
        if (localStorageContent === null)
            return null;
        var storedData = JSON.parse(localStorageContent);
        return storedData;
    }
    return (react_1.default.createElement("div", { className: "popup " + (open ? 'popup-active' : '') },
        react_1.default.createElement("div", { className: "popup__content" },
            react_1.default.createElement("div", { className: "popup__info" },
                react_1.default.createElement("div", { className: "popup__heading" }, content && content.title),
                react_1.default.createElement("div", null, (content === null || content === void 0 ? void 0 : content.isFirstPublish) && "Ny artikkel" || "Ny oppdatering"),
                content && content.url && (react_1.default.createElement("div", null,
                    react_1.default.createElement("a", { href: content.url }, "Les mer")))),
            react_1.default.createElement("div", null,
                react_1.default.createElement("button", { className: "popup__btn-close", onClick: function () { closeMessage(content); } }, "Lukk")))));
};
var initPopup = function () {
    var nodeId = "popup-root";
    var appRootNode = document.getElementById(nodeId);
    if (!appRootNode) {
        console.warn("Cannot find node with ID '" + nodeId + "'. The React app cannot be rendered.");
        return;
    }
    var endpointUrl = appRootNode === null || appRootNode === void 0 ? void 0 : appRootNode.getAttribute("data-react-props");
    if (!endpointUrl) {
        console.warn("missing props for '" + nodeId + "'. The react app cannot be rendered.");
        return;
    }
    react_dom_1.default.render(react_1.default.createElement(Popup, {
        endpointUrl: endpointUrl
    }), appRootNode);
};
initPopup();
